type ReadyCallback = (jq: JQuery) => void;

export const loadJq = (callback: ReadyCallback) => {
  if (window.jQuery) {
    callback(window.jQuery);
  } else {
    import("jquery").then((f) => {

      window.$ = f.default
      window.jQuery = f.default
      // f.loadJQuery();
      callback(window.jQuery);
    })
  }
}